const removeActionFromLocal = (consultationId, actionNumber) => {
  try {
    const key = `quick_actions_${consultationId}`;
    const stored = localStorage.getItem(key);

    if (!stored) return;

    const actions = JSON.parse(stored);

    const updatedActions = actions.filter(
      (a) =>
        String(a.ActionNumber || a.actionNumber).trim() !==
        String(actionNumber).trim()
    );

    if (updatedActions.length === 0) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(updatedActions));
    }
  } catch (e) {
    console.error("Failed to remove action from local storage", e);
  }
};

export default removeActionFromLocal;
